// src/customSplitLink.ts
import { uniq } from "@quromedical/utils";
import {
  createTRPCProxyClient,
  httpBatchLink,
  splitLink
} from "@trpc/client";
var createHttpBatchLink = (url, headers) => {
  return httpBatchLink({
    url,
    headers
  });
};
function recursiveSplitLink(procedureMap, baseURL, headers) {
  const map = Object.assign({}, procedureMap);
  const keys = Object.keys(map);
  if (keys.length === 0 || keys.length === 1) {
    return createHttpBatchLink(baseURL, headers);
  }
  const paths = uniq(Object.values(map));
  const currentPah = paths[0];
  const url = `${baseURL}/${currentPah}`;
  const leftOverPaths = keys.reduce((acc, key) => {
    const value = map[key];
    if (value !== currentPah) {
      acc[key] = value;
    }
    return acc;
  }, {});
  return splitLink({
    condition: (op) => {
      const router = map[op.path];
      return router === currentPah;
    },
    true: createHttpBatchLink(url, headers),
    false: recursiveSplitLink(leftOverPaths, baseURL, headers)
  });
}
function createCustomTRPCProxyClient(baseURL, headers, procedureMap) {
  return createTRPCProxyClient({
    links: [recursiveSplitLink(procedureMap, baseURL, headers)]
  });
}
export {
  createCustomTRPCProxyClient,
  recursiveSplitLink
};
//# sourceMappingURL=index.mjs.map